export const COSMIC_MOTION_STORAGE_KEY = "raava.cosmic.device-motion.v1";
export const COSMIC_MOTION_EVENT = "raava:cosmic-device-motion";

export function isCosmicDeviceMotionEnabled() {
  if (typeof window === "undefined") return false;
  const saved = window.localStorage.getItem(COSMIC_MOTION_STORAGE_KEY);
  if (saved !== null) return saved === "enabled";
  return typeof window.DeviceOrientationEvent?.requestPermission !== "function";
}

function broadcast(enabled) {
  window.localStorage.setItem(COSMIC_MOTION_STORAGE_KEY, enabled ? "enabled" : "disabled");
  window.dispatchEvent(new CustomEvent(COSMIC_MOTION_EVENT, { detail: { enabled } }));
}

export async function enableCosmicDeviceMotion() {
  if (typeof window === "undefined" || typeof window.DeviceOrientationEvent === "undefined") return false;
  if (typeof window.DeviceOrientationEvent.requestPermission === "function") {
    const permission = await window.DeviceOrientationEvent.requestPermission();
    if (permission !== "granted") {
      broadcast(false);
      return false;
    }
  }
  broadcast(true);
  return true;
}

export function disableCosmicDeviceMotion() {
  if (typeof window === "undefined") return;
  broadcast(false);
}
